<!--begin::Root-->
<div class="d-flex flex-column flex-root">
  <!--begin::Page-->
  <div class="page d-flex flex-column flex-column-fluid position-relative" [ngClass]="{'custom-layout-bg':isHomeRoute}">

    <ng-container *ngIf="(modeEdit$ | async) !== false">
      <ng-container *lcmsPermission="'CAN-EDIT-PLATEFORME'">
        <ng-container *ngIf="isEditMode$ | async as isEditMode">
          <button class="btn btn-icon position-fixed top-50 start-0 m-4 p-8 edit-btn d-none d-lg-flex" [disabled]="isEditMode.loading" (click)="editMode()" [ngClass]="{'btn-primary bg-primary': isEditMode?.status}">
            <ng-container *ngIf="!isEditMode.loading;else loadingTemplate">
              <i class="fas fa-pen fs-3"></i>
            </ng-container>
            <ng-template #loadingTemplate>
              <span class="indicator-progress d-block">
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </ng-template>
          </button>
        </ng-container>
      </ng-container>
    </ng-container>
<!-- mb-20   bottom-0 [ngClass]="(canAccess$ | async) === true ? 'd-flex' : 'd-none'"-->
      <div *lcmsPermission="['||','CAN-ADD-TAGS','CAN-LIST-GROUPS','CAN-MANAGE-GROUPS','CAN-ADD-GROUPS' , 'CAN-MANAGE-USERS','CAN-DISPLAY-USERS','CAN-DISPLAY-USERS-BY-GROUP','CAN-ASSIGN-USERS-TO-GROUP','CAN-ADD-USERS-BY-EXCEL','CAN-ADD-USER' , 'CAN-ADD-USERS-BY-EXCEL' , 'CAN-ASSIGN-USERS-TO-GROUP' , 'CAN-MANAGE-TAGS','CAN-ADD-TAGS', 'CAN-LIST-TAGS','CAN-MANAGE-EVENT','CAN-LIST-EVENT' , 'CAN-ADD-EVENT' ,'CAN-MANAGE-NOTIFICATION' , 'CAN-ADD-TEMPLATE'  , 'CAN-MANAGE-TEMPLATE', 'CAN-LIST-TEMPLATE' , 'CAN-ADD-ARTICLE', 'CAN-MANAGE-PERMISSION']" class=" d-flex engage-toolbar d-flex position-fixed fw-bolder zindex-999 p-4 mt-18  top-50 start-0 gap-2"  >
<!--        rounded-start-0-->
        <button
          class="engage-help-toggle btn btn-primary shadow-sm rounded p-3 btn-flex"
          data-bs-toggle="offcanvas"
          data-bs-target="#settingAdminBar"
          aria-controls="settingAdminBar"
          (mouseenter)="hover(true)"
          (mouseleave)="hover(false)"
        >
          <i class="fa-solid fa-user-gear fs-3 p-1"></i>
          <span class="long-text" [ngClass]="{'show-long-text': isHovering}">{{"profile.administration" | translate}}</span>
        </button>
      </div>

    <app-header id="kt_header" class="header align-items-stretch border-bottom shadow-sm" [ngClass]="headerCSSClasses" #ktHeader>
    </app-header>
    <lcms-alert-simple></lcms-alert-simple>
    <!--begin::Container-->
    <div id="kt_content_container" class="d-flex flex-column-fluid align-items-stretch" [ngClass]="contentContainerClasses">
      <!-- <ng-container *ngIf="asideDisplay">
        <ng-container *ngIf="headerFixedDesktop">
          <app-aside id="kt_aside" class="aside" data-kt-drawer="true" data-kt-drawer-name="aside"
            data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
            data-kt-drawer-width="{default:'200px', '300px': '225px'}" data-kt-drawer-direction="start"
            data-kt-drawer-toggle="#kt_aside_toggle" data-kt-sticky="true" data-kt-sticky-name="aside-sticky"
            data-kt-sticky-offset="{default: false, lg: '1px'}" data-kt-sticky-width="{lg: '225px'}"
            data-kt-sticky-left="auto" data-kt-sticky-top="94px" data-kt-sticky-animation="false"
            data-kt-sticky-zindex="95">
          </app-aside>
        </ng-container>
        <ng-container *ngIf="!headerFixedDesktop">
          <app-aside id="kt_aside" class="aside" data-kt-drawer="true" data-kt-drawer-name="aside"
            data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
            data-kt-drawer-width="{default:'200px', '300px': '225px'}" data-kt-drawer-direction="start"
            data-kt-drawer-toggle="#kt_aside_toggle">
          </app-aside>
        </ng-container>
      </ng-container> -->
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid mt-5 mt-lg-10" id="kt_wrapper">
        <!--begin::Content-->
        <div id="kt_content" class="content flex-column-fluid">

          <!-- <ng-container *ngIf="title$ | async">
            <ng-container *ngIf="toolbarDisplay">
              <app-toolbar></app-toolbar>
            </ng-container>
          </ng-container> -->


          <!--begin::Post-->
          <div class="content" id="kt_content">

            <app-content id="kt_content_container" ></app-content>
          </div>
          <!--end::Post-->
        </div>
        <!--end::Content -->
        <app-footer class="footer py-4 d-flex flex-lg-column" [ngClass]="footerCSSClasses" id="kt_footer"></app-footer>
      </div>
      <!--end::Wrapper-->
      <ng-container *ngIf="showSidebar$ | async">
        <app-sidebar class="sidebar p-5 px-lg-0 py-lg-11" data-kt-drawer="true" data-kt-drawer-name="sidebar"
          data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true"
          data-kt-drawer-width="275px" data-kt-drawer-direction="end" data-kt-drawer-toggle="#kt_sidebar_toggle">
        </app-sidebar>
      </ng-container>
    </div>
    <!--end::Container-->
  </div>
  <!--end::Page-->
</div>
<!--end::Root-->

<app-scripts-init></app-scripts-init>
<div class="OFAG position-fixed mb-5" *ngIf="OFAG && lang$ | async as language">
  <img [src]="'/assets/img/OFAG-logo-'+language.lang+'.png'" alt="" srcset="">
</div>
<app-scroll-top></app-scroll-top>

<!-- begin:: Drawers -->
<!-- <app-activity-drawer></app-activity-drawer>-->
<app-messenger-drawer></app-messenger-drawer>
<lcms-favorites-list></lcms-favorites-list>
<lcms-toggle-notif></lcms-toggle-notif>

<!-- end:: Drawers -->

<!-- end:: Engage -->
<app-engages></app-engages>
<!-- end:: Engage -->

<!-- begin:: Modals -->
<!-- <app-main-modal></app-main-modal>
<app-invite-users-modal></app-invite-users-modal>
<app-upgrade-plan-modal></app-upgrade-plan-modal> -->
<!-- end:: Modals -->

<lcms-spash-notif></lcms-spash-notif>

<!--<lcms-question-notif></lcms-question-notif>-->

<lcms-aside-admin></lcms-aside-admin>
